export const PLAN_INTEREST_LINK_LABEL = "더 큰 요금제 알림 받기";
